import React from "react";
import { useSelector } from "react-redux";
import { SingleForward2Hoc } from "../../../../../../assets/images";
import CustomIcon from "../../../../../../assets/images/CustomIcon";
import Modal from "../../../../Common/Modal";
import ForwardPopUp from "../../../PopUp/ForwardPopUp.js";
const ForwardCommon = (props = {}) => {
    const {
        jid = "",
        forward,
        popUpStatus,
        uploadStatus = 0,
        showForwardPopUp,
        closeForwardPopUp,
        pageType
    } = props;
    const globalState = useSelector(state => state)
  const { mf_SingleForward2 } = globalState?.dynamicIcon?.data;
    return (
        <React.Fragment>
            {uploadStatus === 2 && !forward && pageType === "conversation" && (
                <span title="Forward" className="SingleForward" onClick={showForwardPopUp}>
                    <i>
                    <CustomIcon icon={mf_SingleForward2 ? mf_SingleForward2 : <SingleForward2Hoc viewBox="0 0 9.157 8.133"/>} /> 
                    </i>
                </span>
            )}

            {popUpStatus && (
                <Modal containerId="container">
                    <ForwardPopUp activeJid={jid} closeMessageOption={closeForwardPopUp} closePopup={closeForwardPopUp} />
                </Modal>
            )}
        </React.Fragment>
    );
};

export default ForwardCommon;
